import React, { useContext } from "react";
import { Box, Flex, styled } from "@acko-tech/building-blocks.ui.common";
import { connect } from "react-redux";

import ImageContainer from "@components/imageContainer";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { CommonProps } from "@utils/interface";
import { Context } from "@components/useContext/context";

import DOMPurify from "isomorphic-dompurify";

interface IBenefits extends CommonProps {
  benefits: { image: any; description: string; is_garage_link?: boolean }[];
}

export const BenefitItem = styled(Flex)`
  gap: 0.5rem;
  align-items: center;
`;

export const BenefitText = styled(Flex)`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #36354c;
  cursor: ${(props) => props?.is_link && "pointer"};
`;

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const Benefits = (props: IBenefits) => {
  const { benefits, is_visible, actions } = props;
  const { on_click } = actions || {};
  const { isDesktop } = useContext(Context);

  const handleClick = () => {
    if (on_click?.length > 0) {
      on_click?.forEach((eachFunc: any) => {
        typeof eachFunc.funCall === "function" &&
          eachFunc.funCall(eachFunc.args);
      });
    }
  };
  return (
    <Box style={{ width: "max-content" }}>
      {is_visible && (
        <Flex style={{ flexDirection: "column", gap: "12px" }}>
          {benefits?.map((b, index) => {
            return (
              <BenefitItem
                key={`${b.description}-${index}`}
              >
                <ImageContainer
                  imgSrc={b.image}
                  width={isDesktop ? 20 : 16}
                  height={isDesktop ? 20 : 16}
                  alt="icon"
                />
                <BenefitText
                  is_link={b?.is_garage_link}
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(b.description)
                  }}
                  onClick={() => {
                    b?.is_garage_link && handleClick();
                  }}
                />
              </BenefitItem>
            );
          })}
        </Flex>
      )}
    </Box>
  );
};

export default connect(mapStateToProps)(Benefits);
